/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaClasesTecnicasVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaClasesTecnicas: React.FunctionComponent<ITablaClasesTecnicasVistaProps & InjectedIntlProps> = ({
    clasesTecnicass,
    cargarClasesTecnicas,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={clasesTecnicass}
            actions={acciones(manejarFormulario, cargarClasesTecnicas, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaClasesTecnicas);
